import { useAuthInfo } from '@sweetauth/core'

import { useBillingOrganization } from '@/hooks/billing/useBillingOrganization'
import { useIsTrialPeriod } from '@/hooks/billing/useIsTrialPeriod'

export const useCanAccessBasic = () => {
  const { isTrialPeriod } = useIsTrialPeriod()
  const { data: billingOrganization, isLoading: isLoadingBillingOrganization } =
    useBillingOrganization()
  const { isLoggedIn, loading: isLoadingAuthInfo } = useAuthInfo()
  const isLoading = isLoadingBillingOrganization || isLoadingAuthInfo
  return {
    canAccessBasic:
      isLoggedIn &&
      billingOrganization !== undefined &&
      billingOrganization !== null &&
      (billingOrganization.tier !== 'free' || isTrialPeriod),
    isLoading,
  }
}
